import { Pipe, PipeTransform } from '@angular/core';
import { conformToMask } from 'angular2-text-mask';
import { Mascaras } from 'environments/resource';
// import { validate_cnpj, MASKS } from '../core/utils';

@Pipe({
    name: 'cpf',
})
export class CPFPipe implements PipeTransform {
    transform(cpfValue: any) {
        if (!cpfValue) {
            return '';
        }

        return conformToMask(
            cpfValue,
            Mascaras.mascaraCPF,
            { guide: false }
        ).conformedValue;
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/cpf.pipe.ts